<template>
  <div>
    <div v-loading="loadingView" />
    <div v-if="!loadingView">
      <router-view
        :brands="brands"
        :steps="steps"
      />
    </div>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';

const req = new Request();

export default {
  data() {
    return {
      steps: null,
      brands: null,
    };
  },
  computed: {
    loadingView() {
      return (this.steps || []).length <= 0 || (this.brands || []).length <= 0;
    },
  },
  created() {
    this._getSteps();
    this._getBrands();
  },
  methods: {
    // 获取所有的跟进步骤
    async _getSteps() {
      try {
        const params = {
          type: '1',
        };
        const res = await req.send(req.Apis.sales.common.config, params);
        if (res.code === 200) {
          this.steps = [...res.data] || [];
        }
      } catch (err) {
        console.error(`获取进步骤失败：${err.message || '未知错误'}`);
      }
    },

    // 获取品牌
    async _getBrands() {
      try {
        const params = {
          type: '2',
        };
        const res = await req.send(req.Apis.sales.common.config, params);
        if (res.code === 200) {
          this.brands = [...res.data] || [];
        }
      } catch (err) {
        console.error(`获取品牌失败：${err.message || '未知错误'}`);
      }
    },
  },
};
</script>
